import * as Yup from 'yup';

import {
  NOTIFICATION_TYPE_DIVISION_USERS,
  NOTIFICATION_TYPE_DIVISION_EMAIL,
  NOTIFICATION_TYPE_SPECIFIED_USER,
} from './store/constants';

import {
  // SERVICE_61_EXPERT_APPOINTMENT, SERVICE_CALL_TOW_TRUCK, SERVICE_CALL_MANIPULATOR_TRUCK,
  SERVICE_BRING_FUEL,
  SERVICE_START_ENGINE,
  SERVICE_REPLACE_WHEEL,
  SERVICE_OPEN_DOOR,  
} from 'modules/core/constants/services';

export const orderCreateValidationSchema = Yup.object().shape({
  serviceId: Yup.string()
    .nullable()
    .required('Укажите сервис'),
  clientId: Yup.string()
    .required('Укажите клиента'),
  statusRefValueId: Yup.string()
    .required('Укажите статус заявки'),
});

export const orderUpdateValidationSchema = Yup.object().shape({
  cost: Yup.number()
    .nullable()
    .min(0, 'Только больше нуля'),
  axle1TireBrandId: Yup.number()
    .nullable()
    .test(
      'axle1TireBrandId test',
      'Укажите производителя шин',
      (value, context) => {
        if ((context?.parent?.serviceId === 69)
          && (context?.parent?.storedObjectRefValueId !== 443)
          && ((value ?? 0) !== value)) return false;
        return true;
      }
    ),
  axle2TireBrandId: Yup.number()
    .nullable()
    .test(
      'axle2TireBrandId test',
      'Укажите производителя шин',
      (value, context) => {
        if ((context?.parent?.serviceId === 69)
          && ((value ?? 0) !== value)
          && (context?.parent?.storedObjectRefValueId !== 443)
          && context?.parent?.showSecondAxle) return false;
        return true;
      }
    ),
  axle1TireModelId: Yup.number()
    .nullable()
    .test(
      'axle1TireModelId test',
      'Укажите модель шин',
      (value, context) => {
        if ((context?.parent?.serviceId === 69)
          && (context?.parent?.storedObjectRefValueId !== 443)
          && ((value ?? 0) !== value)) return false;
        return true;
      }
    ),
  axle2TireModelId: Yup.number()
    .nullable()
    .test(
      'axle2TireModelId test',
      'Укажите модель шин',
      (value, context) => {
        if ((context?.parent?.serviceId === 69)
          && context?.parent?.showSecondAxle
          && (context?.parent?.storedObjectRefValueId !== 443)
          && ((value ?? 0) !== value)) return false;
        return true;
      }
    ),
  axle1TireWidthRefValueId: Yup.number()
    .nullable()
    .test(
      'axle1TireWidthRefValueId test',
      'Укажите ширину шин',
      (value, context) => {
        if ((context?.parent?.serviceId === 69)
          && (context?.parent?.storedObjectRefValueId !== 443)
          && ((value ?? 0) !== value)) return false;
        return true;
      }
    ),
  axle1TireHeightRefValueId: Yup.number()
    .nullable()
    .test(
      'axle1TireHeightRefValueId test',
      'Укажите высоту шин',
      (value, context) => {
        if ((context?.parent?.serviceId === 69)
          && (context?.parent?.storedObjectRefValueId !== 443)
          && ((value ?? 0) !== value)) return false;
        return true;
      }
    ),
  axle2TireWidthRefValueId: Yup.number()
    .nullable()
    .test(
      'axle2TireWidthRefValueId test',
      'Укажите ширину шин',
      (value, context) => {
        if ((context?.parent?.serviceId === 69)
          && context?.parent?.showSecondAxle
          && (context?.parent?.storedObjectRefValueId !== 443)
          && ((value ?? 0) !== value)) return false;
        return true;
      }
    ),
  axle2TireHeightRefValueId: Yup.number()
    .nullable()
    .test(
      'axle2TireHeightRefValueId test',
      'Укажите высоту шин',
      (value, context) => {
        if ((context?.parent?.serviceId === 69)
          && context?.parent?.showSecondAxle
          && (context?.parent?.storedObjectRefValueId !== 443)
          && ((value ?? 0) !== value)) return false;
        return true;
      }
    ),
  diameterWheelRefValueId: Yup.number()
    .nullable()
    .test(
      'diameterWheelRefValueId test',
      'Укажите диаметр',
      (value, context) => {
        if ((context?.parent?.serviceId === 69)
          && (context?.parent?.storedObjectRefValueId !== 443)
          && ((value ?? 0) !== value)) return false;
        return true;
      }
    ),   
  rimsTypeRefValueId: Yup.number()
    .nullable()
    .test(
      'rimsTypeRefValueId test',
      'Укажите тип дисков',
      (value, context) => {
        if ((context?.parent?.serviceId === 69)
        && ((context?.parent?.storedObjectRefValueId === 443)
          || (context?.parent?.storedObjectRefValueId === 380))
        && ((value ?? 0) !== value)) return false;
        return true;
      }
    ),
  rimsOriginRefValueId: Yup.number()
    .nullable()
    .test(
      'rimsTypeRefValueId test',
      'Укажите Оригинал/Реплика',
      (value, context) => {
        if ((context?.parent?.serviceId === 69)
        && ((context?.parent?.storedObjectRefValueId === 443)
          || (context?.parent?.storedObjectRefValueId === 380))
        && ((value ?? 0) !== value)) return false;
        return true;
      }
    ),

  reasonForCancellationRefValueId: Yup.number()
    .nullable()
    .test(
      'reasonForCancellationRefValueId test',
      'Укажите причину отмены',
      (value, context) => {
        if (((context?.parent?.serviceId === 13) || (context?.parent?.serviceId === 42))
        && (context?.parent?.statusRefValueId === 121)
        && ((value ?? 0) !== value)) return false;
        return true;
      }
    ),

  outsideMkadDistanceInKm: Yup.number()
    .nullable()
    .typeError('Допускается только число')
    .min(0, 'Не допускается отрицательное число')
    .integer('Только целое число'),

});

export const orderPhotoCreationSchema = Yup.object().shape({
  documentType: Yup.string()
    .required('Укажите тип фото'),
  position: Yup.string()
    .when('documentType', {
      is: 'AVARCOM_INCIDENT_PHOTO',
      then: (schema) => schema.required('Укажите позицию фото'),
    })
    .when('documentType', {
      is: 'DOCUMENT',
      then: (schema) => schema.required('Укажите тип документа'),
    }),
});

export const orderCommentsSchema = Yup.object().shape({
  notificationTypeRefValueId: Yup.string()
    .required('Укажите кому отправлять комментарий'),
  divisionId: Yup.string()
    .nullable()
    .when('notificationTypeRefValueId', {
      is: NOTIFICATION_TYPE_DIVISION_USERS,
      then: (schema) => schema.required('Укажите подразделение'),
    })
    .when('notificationTypeRefValueId', {
      is: NOTIFICATION_TYPE_DIVISION_EMAIL,
      then: (schema) => schema.required('Укажите подразделение'),
    }),
  userId: Yup.string()
    .nullable()
    .when('notificationTypeRefValueId', {
      is: NOTIFICATION_TYPE_SPECIFIED_USER,
      then: (schema) => schema.required('Укажите пользователя'),
    }),
  comment: Yup.string()
    .trim()
    .required('Введите комментарий'),
});

export const insurancePolicyValidationSchema = Yup.object().shape({
  insuranceTypeRefValueId: Yup.number()
    .nullable()
    .required('Укажите тип полиса'),
  insuranceCompanyId: Yup.number()
    .nullable()
    .required('Укажите страховую компанию'),
  insuranceNumber: Yup.string(),
  startDate: Yup.mixed()
    .nullable()
    .test(
      'testValidDate',
      'Дата начала должна быть меньше даты окончания',
      function (value) {
        if ((value && this.parent.expirationDate) && (value >= this.parent.expirationDate)) {
          return false;
        }
        return true;
      }
    ),
  expirationDate: Yup.mixed()
    .nullable()
    .test(
      'testValidDate',
      'Дата окончания должна быть больше даты начала',
      function (value) {
        if ((value && this.parent.startDate) && (value <= this.parent.startDate)) {
          return false;
        }
        return true;
      }
    ),
});

export const OrderMapRefusalModalFormValidationSchema = Yup.object().shape({
  refusalRefValueId: Yup.number()
    .required('Укажите причину отказа'),
  comment: Yup.string()
    .nullable()
    .when('refusalRefValueId', {
      is: 503,
      then: (schema) => schema.required('Укажите причину в комментарии'),
    })
  ,
});

export const OrderCommunicationModalFormValidationSchema = Yup.object().shape({
  typeRefValueId: Yup.number()
    .nullable()
    .required('Укажите тип контакта'),
  currentNote: Yup.string()
    .required('Укажите текущий контакт'),
  nextDate: Yup.number()
    .nullable()
    .test(
      'nextDate test',
      'Укажите следующую дату',
      (value, context) => {
        if (!context?.parent?.nextNote && !value) return true;
        if (context?.parent?.nextNote && !value) return false;
        return true;
      }
    ),
  nextNote: Yup.string()
    .nullable()
    .test(
      'nextNote test',
      'Укажите следующий контакт',
      (value, context) => {
        if (!context?.parent?.nextDate && !value) return true;
        if (context?.parent?.nextDate && !value) return false;
        return true;
      }
    ),

});

export const TBankCreateOrderValidationSchema = Yup.object().shape({
  serviceId: Yup.number()
    .nullable()
    .required('Укажите сервис'),
  clientId: Yup.string()
    .nullable()
    .required('Укажите клиента'),
  address: Yup.string()
    .nullable()
    .required('Укажите адрес'),
  /* vehicleId: Yup.string()
    .nullable()
    .required('Укажите автомобиль'),
   insuranceCompanyId: Yup.number()
    .nullable()
    .required('Укажите страховую компанию'),
  insuranceNumber: Yup.string()
    .nullable()
    .required('Укажите номер полиса'), */
  userComment: Yup.string()
    .required('Укажите, что произошло'),
});

export const TBankUpdateOrderValidationSchema = Yup.object().shape({
  address: Yup.string()
    .nullable()
    .required('Укажите адрес'),
  /* vehicleId: Yup.string()
    .nullable()
    .required('Укажите автомобиль'),
   insuranceCompanyId: Yup.number()
    .nullable()
    .required('Укажите страховую компанию'),
  insuranceNumber: Yup.string()
    .nullable()
    .required('Укажите номер полиса'), */
  userComment: Yup.string()
    .required('Укажите что произошло'),
});

const isHelpTypeService = (serviceId: number | null) => {
  if ([SERVICE_OPEN_DOOR, SERVICE_REPLACE_WHEEL, SERVICE_START_ENGINE , SERVICE_BRING_FUEL ]
    .includes(serviceId)) return true;
  return false;
}

export const OrderEvacuatorCreateMasterValidationSchema = Yup.object().shape({
  serviceId: Yup.number()
    .nullable()
    .required('Укажите сервис'),
  clientId: Yup.string()
    .nullable()
    .required('Укажите клиента'),
  address: Yup.string()
    .nullable()
    .required('Укажите адрес'),
  // vehicleId: Yup.string()
  //   .nullable()
  //   .required('Укажите автомобиль'),
  reasonForEvacuationRefValueId: Yup.number()
    .nullable()
    .when('serviceId', {
      // доя тех.помощи не проверяем
      is: isHelpTypeService,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) => schema.required('Укажите причину эвакуации'),
    }),
    
  wheelLockRefValueId: Yup.number()
    .nullable()
    .when('serviceId', {
      // доя тех.помощи не проверяем
      is: isHelpTypeService,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) => schema.required('Укажите заблокированные колёса'),
    }),
  fuelTypeRefValueId: Yup.number()
    .nullable()
    .when('serviceId', {
      // доя тех.помощи не проверяем
      is: (serviceId) => serviceId !==SERVICE_BRING_FUEL,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) => schema.required('Укажите тип топлива'),
    }),    
});

export const OrderEvacuatorUpdateMasterValidationSchema = Yup.object().shape({
  /* serviceId: Yup.number()
    .nullable()
    .required('Укажите сервис'),
  clientId: Yup.string()
    .nullable()
    .required('Укажите клиента'),
  address: Yup.string()
    .nullable()
    .required('Укажите адрес'),
  vehicleId: Yup.string()
    .nullable()
    .required('Укажите автомобиль'),
  wheelLockRefValueId: Yup.number()
    .required('Укажите заблокированные колёса'),*/
});

export const smsInputValidationSchema = Yup.object().shape({
  smsInput: Yup.string()
    .nullable()
    .matches(/^[0-9]+$/i, 'Допускаются только цифры')
    .max(6, 'Максимум 6 символов')
    .test('not-empty ', 'Введите СМС', (value) => {
      return !!value;
    }),
});
